module.exports = __webpack_public_path__ + "static/img/icon_default_img.9fc3f15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon_default_img.png
// module id = Qjp7
// module chunks = 28